import axios, { AxiosResponse } from 'axios';
import { iTagShort__API } from '../apiSchema';
import { getApiLink } from '../api';
import { useData } from '../hooks/useData';
import { iTag, Tag } from '../models/Tag';

/**
 * Fetch list of tags. When a ribbon (aka category) id is provided, the backend
 * returns only the tags that belong to that ribbon. If no id is supplied the
 * endpoint returns the full tag list.
 *
 * @param ribbonId Optional ribbon/category identifier.
 */
async function getTags(ribbonId?: number): Promise<iTag[]> {
    const endpoint = ribbonId ? `Tag/GetTagsByRibbon?ribbonId=${ribbonId}` : `Tag/GetTagsByRibbon`;

    const response: AxiosResponse<iTagShort__API[]> = await axios.get(getApiLink(endpoint));

    return response.data.map((p) => new Tag({ apiModel: p }));
}

export default function useTags(ribbonId?: number) {

    return useData([], getTags, ribbonId);
}